<template>
  <b-card>
    <b-row>
      <b-col md="10">
        <h3>{{ $t('reimbursement') }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/new-reimbursement">{{
              $t('reimbursement')
            }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-col>
      <b-col md="2 mt-3">
        <b-button
          v-b-tooltip.hover.top
          :title="$t('exportExcel')"
          @click="doExportToExcel"
          variant="info"
          class="mb-2 btn-download float-right"
          ><font-awesome-icon icon="download"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom mb-2"></div>
    <b-row>
      <b-col md="8" class="mb-3">
        <div class="d-flex">
          <span class="my-3 dashboard-border"
            ><router-link to="/new-reimbursement/general">{{
              $t('reqReimburst')
            }}</router-link></span
          >
          <span class="ml-4 my-3 dashboard-border"
            ><router-link to="/new-reimbursement/payment">{{
              $t('appReimburst')
            }}</router-link></span
          >
          <span class="ml-4 my-3 dashboard-border active"
            ><router-link
              style="color:#0056b3!important;"
              to="/new-reimbursement/history-reimbursement"
              >{{ $route.name }}</router-link
            ></span
          >
          <span class="ml-4 my-3 dashboard-border"
            ><router-link to="/new-reimbursement/category-reimbursement">{{
              $t('reimburstCategory')
            }}</router-link></span
          >
        </div>
      </b-col>
    </b-row>
    <b-form v-on:submit.prevent="getEmployeeName()">
      <b-row>
        <b-col md="12">
          <b-row class="mt-2 mb-2">
            <b-col md="3 mb-2">
              <b-form-input
                class="border-radius"
                :placeholder="$t('employeeName')"
                v-model="tableFilter.search_employee"
              />
            </b-col>
            <b-col md="3 mb-2">
              <!-- <b-form-select v-model="tableFilter.parent" :options="parentList" /> -->
              <date-picker
                v-model="tableFilter.date"
                type="date"
                class="border-radius"
                :placeholder="$t('searchDate')"
              ></date-picker>
            </b-col>
            <b-col md="3 mb-2"> </b-col>
            <b-col md="3 mb-2">
              <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search">
                <font-awesome-icon icon="search" /> {{ $t('filter') }}
              </button>
              <button
                @click="clearFilter()"
                class="ml-0 btn btn-outline-primary float-right"
                id="btn-search"
              >
                <font-awesome-icon icon="times-circle" /> {{ $t('clear') }}
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <div class="border-bottom mb-2"></div>
    <table class="table table-hovered table-striped mb-4">
      <thead>
        <tr>
          <th>{{ $t('date') }}</th>
          <th>{{ $t('employee') }}</th>
          <th>{{ $t('totalPay') }}</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <template v-if="isLoading">
        <tbody>
          <tr>
            <td colspan="10" class="text-center">
              <div class="text-center" style="margin: 3% auto;">
                <b-spinner small type="grow" label="Spinning"></b-spinner>
                <b-spinner small variant="primary" type="grow" label="Spinning"></b-spinner>
                <b-spinner small variant="success" type="grow" label="Spinning"></b-spinner>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
      <template v-else>
        <tbody v-if="paidReimburse.length > 0">
          <tr v-for="(payment, index) in paidReimburse" :key="index">
            <td>
              <a class="font-weight-bold text-primary">
                {{ getDateClock(payment.datetime) }}
              </a>
            </td>
            <td>{{ payment.name }}</td>
            <td>{{ dataAccount.account.currency }} {{ formatPrice(payment.amount) }}</td>
            <td>
              <div :id="'btn-popover-payment-' + index">
                <b-badge :variant="getStatusColor(payment.status)">{{ payment.status }}</b-badge>
              </div>
              <b-popover
                v-if="payment.status === 'Approved'"
                :target="'btn-popover-payment-' + index"
                triggers="hover"
                placement="left"
              >
                <template v-slot:title>Pay</template>
                <b-button
                  variant="primary"
                  size="sm"
                  class="btn-pay-popover"
                  @click="showModalPay('', payment)"
                  ><font-awesome-icon icon="donate"></font-awesome-icon> Pay</b-button
                >
              </b-popover>
            </td>
            <td>
              <a
                v-if="tableFilter.date !== null"
                v-b-tooltip.hover.left
                :title="('detail')"
                class="btn-op icon-info mr-1"
                :href="'#' + '/new-reimbursement' + '/' + payment.uuid"
              ></a>
              <a
                v-else
                v-b-tooltip.hover.left
                :title="$t('detail')"
                class="btn-op icon-info mr-4"
                :href="'#' + $route.path + '/' + payment.uuid + '&paid_time=' + payment.datetime"
              ></a>

              <!-- <b-button
                    variant="primary"
                    size="sm"
                    class="btn-pay-popover"
                    @click="showModalPay('', payment)"
                    ><font-awesome-icon icon="donate"></font-awesome-icon> Pay</b-button
                  > -->
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">There's no data</td>
          </tr>
        </tbody>
      </template>
    </table>
  </b-card>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
// import PaginatedTable from '@/components/PaginatedTable'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: 'payment-reimbursement',
  components: {
    DatePicker,
  },
  data() {
    return {
      isLoading: false,
      dataKey: 'reimbursement',
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        profile: window.AppConfig.apiUrl + 'profile',
        reimbursePaidStats: window.AppConfig.apiUrl + 'reimburse-paid-stats',
        reimbursementType: window.AppConfig.apiUrl + 'reimbursement-type',
        reimbursement: window.AppConfig.apiUrl + 'reimbursement?status=Paid',
        exportPayment: window.AppConfig.apiUrl + 'export-payment-reimbursement',
      },
      columns: [
        {
          key: 'createdAt',
          label: 'Date',
          sortable: true,
        },
        {
          key: 'reimburseCategory.categoryName',
          label: 'Category',
          sortable: true,
        },
        {
          key: 'note',
          label: 'Description',
        },
        {
          key: 'requestedBy.name',
          label: 'Employee',
        },
        {
          key: 'amount',
          label: 'Amount',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'actions',
          lebel: '',
          sortable: true,
        },
      ],
      reimbursementList: [
        {
          value: null,
          text: 'Type',
        },
      ],
      statusList: [
        {
          value: null,
          text: 'Status',
        },
        {
          value: 'Approved',
          text: 'Approved',
        },
        {
          value: 'Paid',
          text: 'Paid',
        },
      ],
      tableFilter: {
        search_employee: this.$route.query.search_employee,
        no_request: this.$route.query.no_request,
        status: this.$route.query.status,
        requested_by: this.$route.query.requested_by,
        date: null,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        userRequestedBy: {
          value: null,
        },
        userApprovedBy: {
          value: null,
        },
        userRejectedBy: {
          value: null,
        },
      },
      reimburseAmountStats: {
        field: [],
      },
      formData: {
        note: '',
        requested_by: '',
        requestedByUuid: '',
        startDate: '',
        endDate: '',
        paidDate: '',
        paidFrom: '',
        paidRefNumber: '',
      },
      list: {
        listAccount: [],
      },
      paidReimburse: [],
    };
  },
  mounted() {
    this.getReimbursePaidData();
    this.getAccountList();
  },
  methods: {
    getReimbursePaidData() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.reimbursePaidStats + '?status=Paid')
        .then((response) => {
          this.paidReimburse = response.data.payment;
          setTimeout(() => {
            this.isLoading = false;
          }, 2500);
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
        });
    },
    doFilter() {
      // eslint-disable-next-line no-self-assign
      this.tableFilter.search_employee = this.tableFilter.search_employee;
      this.tableFilter.reimbursement_type_uuid = this.tableFilter.reimbursementType;
      this.tableFilter.status = this.tableFilter.statusreimbursement;
      this.tableFilter.start_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD')
          : null;
      this.tableFilter.end_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
          : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },
    clearFilter() {
      this.tableFilter.reimbursementType = null;
      this.tableFilter.statusreimbursement = null;
      this.tableFilter.search_employee = null;
      this.tableFilter.search_approved_by = null;
      this.tableFilter.search_rejected_by = null;
      this.tableFilter.date = null;
      this.getEmployeeName();
      // this.$refs.selectableTable.doFilter(this.tableFilter)
    },
    getReimbursementType() {
      this.$http.get(this.apiUrl.reimbursementType + '?limit=100').then((resp) => {
        resp.data._embedded.reimbursementType.forEach((data) => {
          this.reimbursementList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },
    getAccountList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'journal-account' + '?journalAccountType=D')
        .then((response) => {
          response?.data?._embedded?.journal_account?.forEach((data) => {
            this.list.listAccount.push({
              value: data.uuid,
              text: data.journalAccountCode + ' - ' + data.journalAccountName,
            });
          });
        });
    },

    /******** BEGIN FILTER SEARCH EMPLOYEEE & SEARCH BY DATE *********/

    getEmployeeName() {
      this.isLoading = true;
      let url = this.apiUrl.reimbursePaidStats;
      if (
        this.tableFilter.search_employee !== undefined &&
        this.tableFilter.search_employee !== null
      ) {
        url += '?search_employee=' + this.tableFilter.search_employee;
      }
      if (this.tableFilter.date !== null) {
        url += '?paid_date=' + this.$moment(this.tableFilter.date).format('YYYY-MM-DD');
      }
      this.$http.get(url).then((resp) => {
        this.paidReimburse = [];
        if (resp.data.payment) {
          resp.data.payment.forEach((data) => {
            this.paidReimburse.push(data);
          });
          setTimeout(() => {
            this.isLoading = false;
          }, 2500);
        }
      });
    },

    /****************************************** END FILTER **************************************/

    setFormData() {
      this.formData.startDate = this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD');
      this.formData.endDate = this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD');
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // eslint-disable-next-line no-dupe-keys

    doExportToExcel() {
      let url =
        this.apiUrl.exportPayment +
        '?token=' +
        this.$store.getters['account/tokens'].access_token +
        '&status=Paid';
      // if (this.tableFilter.userRequestedBy.value !== undefined && this.tableFilter.userRequestedBy.value !== null) {
      //     url += '&requested_by=' + this.tableFilter.userRequestedBy.value
      // }
      // if (this.tableFilter.reimbursementType !== undefined && this.tableFilter.reimbursementType !== null) {
      //     url += '&reimbursement_type_uuid=' + this.tableFilter.reimbursementType
      // }
      window.open(url);
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },
    getDateClock(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '-';
      }
    },
    reset() {
      this.tableFilter.requestedBy = null;
    },
    showModalPay(type, row) {
      this.formData.requestedByUuid = row.uuid;
      this.type = type;
      if (this.$route.name === 'Payment Reimbursement') {
        this.urlName = 'paid-reimburse';
      }
      this.modelUuid = row.uuid;
      this.$bvModal.show('bv-modal-payment');
    },
    doChangeStatusPay() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + this.urlName, {
          requested_by: this.formData.requestedByUuid,
          note: this.formData.note,
        })
        .then(() => {
          this.isLoading = false;
          this.formData.requestedBy = null;
          this.formData.note = null;
          this.getPaymentReimbursement();
          this.$bvModal.hide('bv-modal-payment');
          this.$store.dispatch('notification/success', this.$route.name + ' has been paid');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'New':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Approved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Completed':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Rejected':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
        case false:
          return 'secondary';
          // eslint-disable-next-line no-unreachable
          break;
        case true:
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case '0':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case '1':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
    getStatusName(val) {
      switch (val) {
        case 'Approved':
          return this.$root.$t('appr');
          // eslint-disable-next-line no-unreachable
          break;
        case 'Requested':
          return this.$root.$t('req');
          // eslint-disable-next-line no-unreachable
          break;

        case 'Rejected':
          return this.$root.$t('rec');
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return this.$root.$t('paid');
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
